import React, { useEffect, useContext, useState } from "react";
import { styled } from "@mui/material/styles";
import TreeView from "@mui/lab/TreeView";
import TreeItem from "@mui/lab/TreeItem";
// { treeItemClasses }
//import { tempObj } from "./temp";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { IconWithToolTip } from "../common";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getDateTime } from "../../utils/data";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@mui/material";
import GroupForm from "./groupForm";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import { appLogger, Http } from "../../utils";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import DeleteDialog from "../../utils/common/DeleteDialog";
import { Nodata } from "../../utils/common/Nodata";

function ExpandMore() {
  return <KeyboardArrowRightIcon className="arrow-up-down" />;
}

function ExpandLess() {
  return <ExpandMoreIcon className="arrow-up-down" />;
}
const StyledTreeItem = styled(TreeItem)(({ theme }) => ({
  [`& .tree-item`]: {
    borderRadius: theme.shape.borderRadius,
    padding: 6,
    marginBottom: 3,
  },
}));
const Item = styled(Paper)(({ theme }) => ({
  boxShadow: "none",
  background: "none",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
}));

function GroupContent(props: any) {
  appLogger.info({
    infoObj: {
      method: "GroupContent",
      component: "groups",
      fileName: "index.tsx",
      props: props,
    },
  });
  const [isLoading, setIsloading] = React.useState(true);
  const [productLists, setProductResponse] = React.useState([] as any);
  const [searchGroups, setSearchGroups] = React.useState([] as any);
  const [search, setSearch] = React.useState("");
  const [groupLists, setGroupLists] = React.useState([] as any);
  // const [tmpGroupIds, setTmpGroupIds] = React.useState([] as any);
  const [editData, setEditData] = React.useState("" as any);
  const [deleteData, setDeleteData] = React.useState("");
  const [editPopup, setEditPopup] = React.useState(false);
  const { userInfo } = useContext(UserContext) as UserLoginInfo;
  const [deletepopupShow, setdeletepopupShow] = React.useState(false);

  useEffect(() => {
    if (
      userInfo &&
      userInfo.idToken &&
      userInfo.idToken.length > 0 &&
      (productLists.length < 1 || props.addOpen)
    ) {
      setIsloading(true);
      Http.get({
        url: `/api/v2/products/0`,
        state: userInfo,
      })
        .then((response: any) => {
          if (
            response &&
            response.productNameList &&
            response.productNameList.length > 0
          ) {
            setProductResponse(response.productNameList);
            setIsloading(false);
            appLogger.info({
              infoObj: {
                method: "useEffect",
                component: "groups",
                fileName: "index.tsx",
                productResponse: response,
              },
            });
          } else {
            // setIsloading(false);
            // props.snackbarShowMessage("No Product Found", "error");
          }
        })
        .catch((error: any) => {
          appLogger.error({
            errObj: {
              method: "useEffect",
              component: "groups",
              fileName: "index.tsx",
              err: error,
            },
          });
          props.snackbarShowMessage(error.message, "error");
          // setIsloading(false);
        });
    }
  }, [userInfo]); // props.addOpen

  const handleEditOpen = (data: any) => {
    // e.preventDefault();
    setEditData(data);
    setEditPopup(true);
  };
  const handleDeletePopup = (e: any, data: any) => {
    e.preventDefault();
    appLogger.info({
      infoObj: {
        method: "handleDeletePopup",
        component: "groups",
        fileName: "index.tsx",
        deleteData: data,
      },
    });
    setDeleteData(data.id);
    setdeletepopupShow(true);
  };
  const createGroup = (postData: any) => {
    appLogger.info({
      infoObj: {
        method: "createGroup",
        component: "groups",
        fileName: "index.tsx",
        createGroupData: postData,
      },
    });
    if (postData.id !== "") {
      setIsloading(true);
      Http.put({
        url: `/api/v2/groups`,
        body: {
          groups: [postData],
        },
        state: userInfo,
      })
        .then((response: any) => {
          appLogger.info({
            infoObj: {
              method: "createGroup",
              component: "groups",
              fileName: "index.tsx",
              groupResponse: response,
            },
          });
          handleClosePopup();
          setIsloading(false);
          props.snackbarShowMessage("Group Modified Successfully", "success");
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "createGroup",
              component: "groups",
              fileName: "index.tsx",
              err: error,
            },
          });
          props.snackbarShowMessage(error.message, "error");
          setIsloading(false);
        });
    } else {
      setIsloading(true);
      Http.post({
        url: `/api/v2/groups`,
        body: {
          groups: [postData],
        },
        state: userInfo,
      })
        .then((response: any) => {
          appLogger.info({
            infoObj: {
              method: "createGroup",
              component: "groups",
              fileName: "index.tsx",
              groupResponse: response,
            },
          });
          props.snackbarShowMessage("Group Created Successfully", "success");
          handleClosePopup();
          setIsloading(false);
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "createGroup",
              component: "groups",
              fileName: "index.tsx",
              err: error,
            },
          });
          props.snackbarShowMessage(error.message, "error");
          setIsloading(false);
        });
    }
  };
  const handleDeleteConfirm = (e: any, data: any) => {
    setIsloading(true);
    appLogger.info(
      {
        infoObj: {
          method: "handleDeleteConfirm",
          component: "groups",
          fileName: "index.tsx",
          dataToDelete: data,
        },
      },
      "Delete Group"
    );
    Http.deleteReq({
      url: `/api/v2/groups/${deleteData}`,
      state: userInfo,
    })
      .then((response: any) => {
        props.snackbarShowMessage("Group Deleted Successfully", "success");
        handleClosePopup();
        setdeletepopupShow(false);
        setIsloading(false);
      })
      .catch((error) => {
        appLogger.error({
          infoObj: {
            method: "handleDeleteConfirm",
            component: "groups",
            fileName: "index.tsx",
            err: error,
          },
        });
        setdeletepopupShow(false);
        setIsloading(false);
      });
  };

  const groupNameSearch = (row: any, e: any) => {
    if (!row.subGroups) {
      if (row.name.toLowerCase().includes(e.target.value.toLowerCase())) {
        return true;
      }
      return false;
    }
    if (row.subGroups && row.subGroups.length > 0) {
      if (row.name.toLowerCase().includes(e.target.value.toLowerCase())) {
        return true;
      }
      return row.subGroups.map((subGroup: any) => {
        return groupNameSearch(subGroup, e);
      });
    }
  };
  let latestLastModifiedDate = 0;
  const getSortedGroups = (temp: any, state: boolean) => {
    if (state) {
      latestLastModifiedDate = temp.lastModifiedOn;
    }
    if (!temp.subGroups) {
      if (temp.lastModifiedOn > latestLastModifiedDate) {
        latestLastModifiedDate = temp.lastModifiedOn;
        temp.latestLastModifedDate = latestLastModifiedDate;
      }
    }
    if (temp.subGroups && temp.subGroups.length > 0) {
      temp.subGroups.map((subGroup: any) => {
        getSortedGroups(subGroup, false);
      });
    }
    return latestLastModifiedDate;
  };
  function compareModifiedDesc(a: any, b: any) {
    if (!b.latestLastModifiedDate && !a.latestLastModifiedDate) {
      return 0;
    }
    if (!b.latestLastModifiedDate) {
      return -1;
    }
    if (!a.latestLastModifiedDate) {
      return 1;
    }
    return b.latestLastModifiedDate > a.latestLastModifiedDate ? 1 : -1;
  }

  const handleSortGroup = (temp: any) => {
    const sortedRows = temp.map((row: any) => {
      row.latestLastModifiedDate = getSortedGroups(row, true);
      return row;
    });
    return sortedRows.sort(compareModifiedDesc);
  };
  const handleSearchTyping = (e: any) => {
    setSearch(e.target.value);
    if (e.target.value !== "") {
      const temp = searchGroups;
      const filteredRows = temp.filter(
        (row: { name: string; subGroups: any }) => {
          const a = groupNameSearch(row, e);
          if (typeof a == "boolean" && a) {
            return true;
          }
          if (Array.isArray(a) && a.flat().includes(true)) {
            return true;
          }
        }
      );
      setGroupLists(filteredRows);
    } else {
      setGroupLists(searchGroups);
    }
  };

  const searchClear = () => {
    setSearch("");
    setGroupLists(searchGroups);
  };

  const deletepopupClose = () => {
    setdeletepopupShow(false);
  };
  const renderLabel = (data: any, type: any) => {
    return (
      <Box sx={{ flexGrow: 1 }}>
        <Grid
          container
          className={
            data && editData && editData.id === data.id
              ? "edit-selected-tree"
              : "non-selected-tree"
          }
          spacing={2}
        >
          <Grid item xs={6} md={3}>
            <Typography className="title-sm-fb">{data.name}</Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography className="info">
              {/* {type == "parent" && ( */}
              <>
                <span className="tree-list-inner-label">Modified On: </span>
                <span className="group-list-info">
                  {" "}
                  {getDateTime(data.lastModifiedOn)}{" "}
                </span>
              </>
              {/* )} */}
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography className="info">
              {/* {type == "parent" && ( */}
              <>
                {/* <span className="group-list-info">
                  <IconWithToolTip message="Users" iconName="icon-group" />
                </span>
                &nbsp;
                <span className="group-list-info">
                  {" "}
                  {data.userCount ? data.userCount : 0}{" "}
                </span>
                &nbsp; &nbsp; */}
                <span className="group-list-info">
                  <IconWithToolTip
                    message="Products"
                    iconName="icon-products"
                  />
                </span>
                &nbsp;
                <span className="group-list-info">
                  {" "}
                  {data.productCount ? data.productCount : 0}
                </span>
              </>
              {/* )} */}
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography className="info">
              <span
                className="group-list-info"
                onClick={() => handleEditOpen(data)}
              >
                <IconWithToolTip message="Edit Group" iconName="icon-edit" />
              </span>
              &nbsp;&nbsp;
              <span
                className="group-list-info"
                onClick={(e: any) => handleDeletePopup(e, data)}
              >
                <IconWithToolTip
                  message="Delete Group"
                  iconName="icon-delete"
                />
              </span>
            </Typography>
          </Grid>
        </Grid>
      </Box>
    );
  };
  const getTreeItemsFromData = (treeItems: any, type: any) => {
    let datatype = "parent";
    return treeItems.map((treeItemData: any) => {
      treeItemData.isParent = true;
      let subGroup = undefined;
      if (treeItemData.subGroups && treeItemData.subGroups.length > 0) {
        subGroup = getTreeItemsFromData(treeItemData.subGroups, "child");
        treeItemData.isParent = false;
        datatype = "child";
      }
      treeItemData.datatype = datatype;
      return (
        <StyledTreeItem
          key={treeItemData.id}
          nodeId={treeItemData.id}
          label={renderLabel(treeItemData, type)}
          children={subGroup}
        />
      );
    });
  };

  const flatGroupList = (groupLists: any) => {
    const tmpGroupIds: any = [];
    const flatSubGroupList = (groupLists: any) => {
      if (groupLists && groupLists.length > 0) {
        groupLists.map((group: any) => {
          tmpGroupIds.push(group.id);
          if (group.subGroups && group.subGroups.length > 0) {
            group.subGroups.map((subGroup: any) => {
              flatSubGroupList([subGroup]);
            });
          }
        });
        appLogger.info({
          infoObj: {
            method: "flatGroupList",
            component: "groups",
            fileName: "index.tsx",
            tmpGroupIds: tmpGroupIds,
          },
        });
        return tmpGroupIds;
      }
    };
    return flatSubGroupList(groupLists);
  };
  const DataTreeView = (groupList: any) => {
    return (
      <TreeView
        defaultCollapseIcon={<ExpandLess />}
        defaultExpandIcon={<ExpandMore />}
        defaultExpanded={
          groupLists && groupLists.length > 0 && flatGroupList(groupLists)
        }
        className="group-wrap"
      >
        {getTreeItemsFromData(groupLists, "parent")}
      </TreeView>
    );
  };
  const handleClosePopup = () => {
    props.setClosePopup();
    setEditPopup(false);
    setEditData("");
  };
  const handleKeyPress = (e: any) => {
    if (e.key === "Enter") {
      // setSearchKeyword(search);
      e.preventDefault();
    }
  };
  return (
    <>
      <div className={isLoading ? " loader" : ""}>
        {groupLists.length > 0 || search.length > 0 ? (
          <div>
            <Grid className="manage-search" container spacing={2}>
              <Grid item xs={12} md={4} lg={2} sx={{ mb: 1 }}>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>Search</InputLabel>
                  <OutlinedInput
                    type="text"
                    value={search}
                    onChange={handleSearchTyping}
                    onKeyPress={handleKeyPress}
                    id="search-input"
                    endAdornment={
                      <>
                        {search && (
                          <InputAdornment position="end" onClick={searchClear}>
                            <IconButton
                              aria-label="search icon"
                              edge="end"
                              className="search-fb-icon"
                            >
                              <CloseIcon className="cursor-pointer" />
                            </IconButton>
                          </InputAdornment>
                        )}
                        <InputAdornment position="end">
                          <IconButton aria-label="search icon" edge="end">
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      </>
                    }
                    label="Search"
                  />
                </FormControl>
              </Grid>
            </Grid>
            {groupLists.length > 0 ? (
              <DataTreeView groupLists={groupLists} />
            ) : (
              !isLoading && (
                <Typography className="no-data text-center" sx={{ m: 4 }}>
                  no groups found
                </Typography>
              )
            )}
          </div>
        ) : (
          !isLoading && <Nodata type="groups" />
        )}
      </div>
      {(props.addOpen || editPopup) && !isLoading && (
        <GroupForm
          productLists={productLists}
          addOpen={(props.addOpen || editPopup) && !isLoading}
          editData={editData}
          setClosePopup={handleClosePopup}
          handleDeletePopup={handleDeletePopup}
          createGroup={createGroup}
        />
      )}
      {deletepopupShow && (
        <DeleteDialog
          deletepopupShow={deletepopupShow}
          deletepopupClose={deletepopupClose}
          handleDeleteConfirm={handleDeleteConfirm}
          type="group"
        />
      )}
    </>
  );
}
export default withSnackbar(GroupContent);
